type PlaybackErrorProps = {
  errorMessage: string;
  errorType: 'network_error' | 'playback_failure';
};

type StreamEndProps = {
  endReason: string;
  listenTime: number;
};

type StreamStartProps = {
  playbackStartTime: number;
  streamInitTime: number;
};

type TrackingData = {
  item: {
    asset: {
      id: string;
      name?: string;
      sub?: {
        id?: string;
        name?: string;
      };
    };
  };
  station: {
    asset: TrackingData['item']['asset'];
    playedFrom?: number;
  };
};

/**
 * Maps component props to data fields for Play/Pause events
 * Also is base payload for other analytics calls
 */
export function generateArtistRadioTrackingData({
  artistId,
  name,
  playedFrom,
  subId,
  subName,
}: {
  artistId: number;
  name?: string;
  playedFrom?: number;
  subId?: string;
  subName?: string;
}): TrackingData {
  return {
    item: {
      asset: {
        id: `artist_profile|${artistId}`,
        name,
        ...(subId && {
          sub: {
            id: `song|${subId}`,
            name: subName,
          },
        }),
      },
    },
    station: {
      asset: {
        id: `artist_profile|${artistId}`,
        name,
        ...(subId && {
          sub: {
            id: `song|${subId}`,
            name: subName,
          },
        }),
      },
      playedFrom,
    },
  };
}

export function getArtistRadioAnalyticsPayload(
  trackingData: TrackingData,
  data: PlaybackErrorProps | StreamEndProps | StreamStartProps,
): {
  item: TrackingData['item'];
  station: TrackingData['station'] &
    (PlaybackErrorProps | StreamEndProps | StreamStartProps);
} {
  return {
    ...trackingData,
    station: {
      ...trackingData.station,
      ...data,
    },
  };
}
